import { useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchCampaignData } from 'workflow/Workflow.actions'

import { useAppDispatch } from 'common/hooks/redux'

import { updateElement } from '../api'
import { contentKeys } from '../queryKeys'

const useUpdateElementMutation = () => {
  const queryClient = useQueryClient()
  const dispatch = useAppDispatch()

  return useMutation({
    mutationFn: updateElement,
    onSuccess: (content, { elementId }) => {
      queryClient.setQueryData(contentKeys.content(content._id), content)
      const campaignId = content.elements?.find(
        (element) => element.element_id === elementId
      )?.campaign_id
      if (campaignId) {
        dispatch(fetchCampaignData(campaignId))
      }
    },
  })
}

export default useUpdateElementMutation
